/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import FindShopLocation from '../../../components/Modals/FindShopLocation';
import ShopList from '../../../components/ShopList';
import Layout from '../../../layouts/User';
import { getShops } from '../../../services/api';
import styles from './index.module.scss';

const breadcrumbs = [
  {
    text: 'หน้าแรก',
    path: '/',
  },
  {
    text: 'ร้านค้าใกล้ฉัน',
    path: '/shops/near-me',
  },
];

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const ShopNearMe: React.FC = () => {
  const [shops, setShops] = useState<any>([]);
  const [currentPageLocation, setCurrentPageLocation] = useState<any>({
    lat: 0,
    long: 0,
  });
  const [isFetchedShop, setIsFetchedShop] = useState(false);
  const currentLocationLatLong = useSelector(
    (state: any) => state.currentLocation
  );
  const [hasShops, setHasShops] = useState(true);
  const [loading, setLoading] = useState(false);
  const [skip, setSkip] = useState(1);
  const [animationTimeout, setAnimationTimeout] = useState(0);
  const user = useSelector((state: any) => state.user);

  const limit = 10;

  const getShopApi = async () => {
    if (loading) return;

    setLoading(true);
    const shopData = await getShops(
      currentPageLocation,
      true,
      skip,
      limit,
      user._id
    );

    if (shopData.length < limit) {
      setHasShops(false);
    }

    setTimeout(() => {
      setIsFetchedShop(true);
      setAnimationTimeout(500);
      setShops([...shops, ...shopData]);
      setSkip(skip + 1);
      setLoading(false);
    }, animationTimeout);
  };

  useEffect(() => {
    if (currentLocationLatLong.lat && !isFetchedShop) {
      setCurrentPageLocation(currentLocationLatLong);
    }
  }, [currentLocationLatLong]);

  const shopLocationState = async (markerPosition: any) => {
    if (markerPosition.lat) {
      setShops([]);
      setSkip(1);
      setHasShops(true);
      setIsFetchedShop(false);
      setAnimationTimeout(0);
      setCurrentPageLocation(markerPosition);
    }
  };

  useEffect(() => {
    if (currentPageLocation.lat) {
      getShopApi();
    }
  }, [currentPageLocation]);

  return (
    <>
      <Layout breadcrumbItems={breadcrumbs} breadcrumbMarginBottom={50}>
        <div className={styles.shopListContainer}>
          {!isFetchedShop ? (
            <div style={{ marginTop: '120px', textAlign: 'center' }}>
              <Spin indicator={antIcon} />
              &nbsp;&nbsp;กำลังโหลดรายการร้านค้า
            </div>
          ) : (
            <>
              {currentPageLocation.lat === 0 ? (
                <div className={styles.locationHelpWrapper}>
                  กรุณาเปิดตำแหน่ง Location...
                </div>
              ) : (
                <>
                  <div className={styles.findShopLocationWrapper}>
                    <FindShopLocation
                      findShopLocationState={shopLocationState}
                      currentLocation={currentPageLocation}
                    />
                  </div>
                  {!shops.length ? (
                    <div className={styles.locationHelpWrapper}>
                      ไม่พบร้านค้าใกล้ฉัน
                    </div>
                  ) : (
                    <InfiniteScroll
                      dataLength={shops.length}
                      next={getShopApi}
                      hasMore={hasShops}
                      loader={
                        <div
                          style={{
                            marginTop: '20px',
                            textAlign: 'center',
                          }}
                        >
                          <Spin indicator={antIcon} />
                          &nbsp;&nbsp;กำลังโหลดรายการร้านค้า
                        </div>
                      }
                      style={{ overflow: 'unset' }}
                    >
                      <ShopList items={shops} from='nearMe' />
                    </InfiniteScroll>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </Layout>
    </>
  );
};
export default ShopNearMe;
